import { Link } from 'react-router-dom';

import Column from '../Column';
import Row from '../Row';
import { useAgencyContext } from '../../hooks/Contexts/AgencyContext';

const SidebarHeader = () => {
    const agency = useAgencyContext();

    const whiteLabelIcon = agency?.whiteLabelPortalEnabled ? agency?.logoUrl : null;

    return (
        <Column gap={0}>
            <Row alignItems="center" justifyContent="center" sx={{ px: 3, py: 2 }}>
                <Row alignItems="center" justifyContent="center" height={32}>
                    <Link
                        to="campaignManager"
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {whiteLabelIcon ? (
                            <img
                                src={whiteLabelIcon}
                                alt="Agency logo"
                                height={32}
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = '/Logo_Black_iCAN.svg';
                                }}
                            />
                        ) : (
                            <img src="/Logo_Black_iCAN.svg" alt="Logo" />
                        )}
                    </Link>
                </Row>
            </Row>
        </Column>
    );
};

export default SidebarHeader;
